import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import AuthService from '../../controllers/AuthService';

const WelcomeDialog = props => {
    const [modalShow, setModalShow] = useState(false);
    const [displayName, setDisplayName] = useState('');

    useEffect(() => {
        const data = AuthService.getCurrentUser();
        const rName = (data.fullName) ? data.fullName : '';
        setDisplayName(rName)
        const firstLogin = localStorage.getItem('firstLogin');

        if (!firstLogin) {
            setTimeout(function () {
                setModalShow(true)
            }, 800);
        }

    }, [])

    const handleClose = () => {
        setModalShow(false)
        localStorage.setItem('firstLogin', true);
    }

    function WelcomeModal(props) {
        return (
            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                dialogClassName='welcome-dialog'
                centered
            >

                <Modal.Body className='text-center'>
                    <div>
                        <img src='/images/welcome-screen/mascot.png' width={'96%'} alt='' />
                    </div>
                    <h4 className='welcome-web font-weight-600'>
                        ขอต้อนรับเข้าสู่ Mindsetmaker
                    </h4>

                    <h2 className='user-displayname font-weight-600'>{displayName}</h2>


                    <p className='remark'>
                        *โปรดตรวจสอบชื่อของคุณอีกครั้งนะคะ <span className='doNotWrap'>หากไม่ถูกต้อง </span>
                        <span className='doNotWrap'>กรุณาแจ้งคุณครู</span> <span className='doNotWrap'> หรือผู้ประสานงานนะคะ</span>
                    </p>
                    <Button id="closeWelcomeDialog" className="btn bluesky card-btn" onClick={handleClose}>ฉันได้ตรวจสอบแล้ว</Button>
                </Modal.Body>
            </Modal>
        );
    }

    return (
        <>
            <WelcomeModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </>
    )



}

export default WelcomeDialog